// extracted by mini-css-extract-plugin
module.exports = {"service":"ServicesList_service__27zeH","serviceImg":"ServicesList_serviceImg__154XO","Shape":"ServicesList_Shape__cUMzP"};